"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoadingModal", {
  enumerable: true,
  get: function get() {
    return _LoadingModal["default"];
  }
});
var _LoadingModal = _interopRequireDefault(require("./LoadingModal"));